import {session} from 'wix-storage';
import wixLocation from 'wix-location';
$w.onReady(function () {
	var sasId = wixLocation.query;
	if (sasId.sscid) {
	session.clear();
	session.setItem('sasId', sasId.sscid);
	}
});